import { z } from 'zod';
export const WhiteLabelParameterSchema = z.enum(['WHITE_LABEL_BASE_URL']);
export const WhiteLabelParameterEnum = WhiteLabelParameterSchema.enum;
